import {TurnState} from '@colonist/game-states'
import {GameClientState} from '../../../../shared/GameClientState'
import {UIGameController} from '../ui_game/UIGameController'
import {UIPopupController} from '../ui_popup/UIPopupController'
import {UIAjaxWrapper} from './UIAjaxWrapper'

interface TournamentResultData {
    tournamentId: string
    gameId: string
    playerName: string[]
    playerVP: number[]
}

export class UIAjaxTournamentResult {
    private static readonly GOOGLE_SHEET = 'https://script.google.com/macros/s/AKfycbwiyX1oFOgbvbcO2BJ7eGfLoJfZyKTYIrGzX8uQoRsBzIFHt8A/exec'
    private static readonly GOOGLE_SHEET_DATA = 'https://docs.google.com/spreadsheets/d/1dNC-0bc_7GcCs4U3j1YeKjbz_LvGM-RjN7I4NU8FsqY/edit#gid=0'

    static sendTournamentData(text: string, gameState: GameClientState, uiGameController: UIGameController): boolean {
        const command = '/logTournament'
        if(text.slice(0, command.length) !== command) return false
        if(uiGameController.currentState.turnState != TurnState.GameEnd) {
            UIPopupController.createSimplePopup({key: 'strings:popups.errors.general.title'}, {key: 'strings:popups.tournament.cannotLogUnfinishedGame'})
            return true
        }
        const tournamendId = text.slice(command.length, text.length).trim()

        const playerNames: string[] = []
        const playerVPs: number[] = []
        for(const player of gameState.players) {
            playerNames.push(player.username)
            // TODO: Fix
            // const privateVictoryPoints = player.victoryPointState.totalPrivateVictoryPoints
            const privateVictoryPoints = 0
            playerVPs.push(privateVictoryPoints)
        }

        const data = {
            tournamentId: tournamendId,
            gameId: uiGameController.gameSettings.id,
            playerName: playerNames,
            playerVP: playerVPs,
        }
        void this.sendData(data)
        return true
    }

    private static async sendData(data: TournamentResultData) {
        const response = await UIAjaxWrapper.postRequestHandler(this.GOOGLE_SHEET, undefined, data)
        if(response == undefined) return

        UIPopupController.createSimplePopup({key: 'strings:popups.tournament.check'}, {key: 'strings:popups.tournament.confirmProperRecording', options: {
            sheetLink: this.GOOGLE_SHEET_DATA,
        }})
    }
}
